import { memo, useCallback } from 'react';

import type { SymbolKey } from '@/entities/symbol';
import { isSameSymbol, isSameSymbolIgnoringPeriod } from '@/entities/symbol';
import { useSelectionFunctions } from '@/features/symbol-selector';
import { useAppSelector } from '@/hooks/redux-hooks';
import CustomCheckbox from '@/shared/ui/primitives/Checkbox';

const SymbolCheckboxComponent = ({
  symbol,
  disabled
}: {
  symbol: SymbolKey;
  disabled?: boolean;
}) => {
  const { isSpotLocked, toggleSymbolInSelection } = useSelectionFunctions();

  const isChecked = useAppSelector(state => {
    const equals = isSpotLocked ? isSameSymbolIgnoringPeriod : isSameSymbol;
    return state.symbolSelector.symbols.some(s => equals(s, symbol));
  });

  const handleChange = useCallback(() => {
    toggleSymbolInSelection(symbol);
  }, [toggleSymbolInSelection, symbol]);

  return (
    <CustomCheckbox
      checked={isChecked}
      disabled={disabled}
      modeLocked={isSpotLocked}
      onLockedClick={handleChange}
      onChange={handleChange}
    />
  );
};

export const SymbolCheckbox = memo(SymbolCheckboxComponent);
